import { obtenerSolicitudTipoId, SolicitudTiposEnum } from "./afiliaciones/solicitud-tipos.enum";

export class Solicitud {
  private static PORTAL_EMPRESAS_ID = 2;

  static mapearDesdeFormularioAFT(solicitudTipo: SolicitudTiposEnum, obj: any) {
    const fechaActual = new Date().toISOString().split('T')[0];
    const horaActual = new Date().toISOString().split('T')[1];

    const fechaConHoraActual = `${fechaActual}T${horaActual}`;
    return new Solicitud(
      fechaConHoraActual,
      obj["beneficiariosAFI"],
      obj["beneficiariosACM"],
      this.PORTAL_EMPRESAS_ID,
      obtenerSolicitudTipoId(solicitudTipo)
    );
  }
  static mapearDesdeFormularioRIT(solicitudTipo: SolicitudTiposEnum) {
    const fechaActual = new Date().toISOString().split('T')[0];
    const horaActual = new Date().toISOString().split('T')[1];
    const fechaConHoraActual = `${fechaActual}T${horaActual}`;
    return new Solicitud(
      fechaConHoraActual,
      0,
      0,
      this.PORTAL_EMPRESAS_ID,
      obtenerSolicitudTipoId(solicitudTipo),
    );
  }
  static mapearDesdeFormularioRIB(solicitudTipo: SolicitudTiposEnum) {
    const fechaActual = new Date().toISOString().split('T')[0];
    const horaActual = new Date().toISOString().split('T')[1];
    const fechaConHoraActual = `${fechaActual}T${horaActual}`;
    return new Solicitud(
      fechaConHoraActual,
      0,
      0,
      this.PORTAL_EMPRESAS_ID,
      obtenerSolicitudTipoId(solicitudTipo),
    );
  }
  constructor(
    public fechaAfiliacion: string,
    public af: number,
    public cm: number,
    public portal: number,
    public tipo: number,
  ) { }
}
